export default __webpack_public_path__ + "static/media/icon_durability.7507ba95.svg";